

















import Vue from 'vue'

export default Vue.extend({
  name: 'ClaimOfferCityListModal',

  props: {
    addresses: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    stateCityList: {},
  }),

  mounted: function () {
    const groupedCities = this.addresses.reduce((reducer, accumulator) => {
      reducer[accumulator.state] = reducer[accumulator.state] || {}
      reducer[accumulator.state][accumulator.city] = {
        name: accumulator.city,
        latitude: accumulator.latitude,
        longitude: accumulator.longitude,
        addressId: accumulator.address_id,
      }

      return reducer
    }, {})

    this.stateCityList = Object.assign(
      {},
      ...Object.entries(groupedCities)
        .sort()
        .map(([state, cities]) => {
          return {
            [state]: Object.assign(
              {},
              ...Object.entries(cities)
                .sort()
                .map(([city, cityData]) => {
                  return {
                    [city]: cityData,
                  }
                })
            ),
          }
        })
    )
  },

  methods: {
    handleCitySelected(city) {
      this.$emit('claim-offer-city-list-modal-city-selected', city)
    },
    closeDialog() {
      this.$emit('claim-offer-city-list-modal-close')
    },
  },
})
